import { EmptyValue } from '@/components/common/EmptyValue';
import { RowActionButton } from './RowActionButton';
import { RowActionGroup } from './RowActionGroup';
import { RowMoreActionsMenu } from './RowMoreActionsMenu';
import type { RowAction } from './rowAction.types';

const MAX_INLINE_ACTION_COUNT = 2;

interface RowActionListProps {
  actions: readonly RowAction[];
  moreActionsAriaLabel: string;
}

function renderActionButton(action: RowAction) {
  return (
    <RowActionButton
      key={action.key}
      label={action.label}
      ariaLabel={action.ariaLabel}
      onClick={action.onSelect}
      tone={action.tone ?? 'default'}
      isDisabled={action.isDisabled === true}
    />
  );
}

export function RowActionList({ actions, moreActionsAriaLabel }: RowActionListProps) {
  const [mainAction, ...otherActions] = actions;
  if (mainAction === undefined) return <EmptyValue />;

  if (actions.length <= MAX_INLINE_ACTION_COUNT) {
    return <RowActionGroup>{actions.map(renderActionButton)}</RowActionGroup>;
  }

  return (
    <RowActionGroup>
      {renderActionButton(mainAction)}
      <RowMoreActionsMenu actions={otherActions} ariaLabel={moreActionsAriaLabel} />
    </RowActionGroup>
  );
}
